const altoK10Sliders = [
  {
    original:
      'https://images-saboomaruti-in.s3.ap-south-1.amazonaws.com/Arena/new-alto-k10/slide-show/exterior_web_01.webp',
    thumbnail:
      'https://images-saboomaruti-in.s3.ap-south-1.amazonaws.com/Arena/new-alto-k10/slide-show/exterior_web_01.webp',
  },
  {
    original:
      'https://images-saboomaruti-in.s3.ap-south-1.amazonaws.com/Arena/new-alto-k10/slide-show/exterior_web_02.webp',
    thumbnail:
      'https://images-saboomaruti-in.s3.ap-south-1.amazonaws.com/Arena/new-alto-k10/slide-show/exterior_web_02.webp',
  },
  {
    original:
      'https://images-saboomaruti-in.s3.ap-south-1.amazonaws.com/Arena/new-alto-k10/slide-show/exterior_web_03.webp',
    thumbnail:
      'https://images-saboomaruti-in.s3.ap-south-1.amazonaws.com/Arena/new-alto-k10/slide-show/exterior_web_03.webp',
  },
  {
    original:
      'https://images-saboomaruti-in.s3.ap-south-1.amazonaws.com/Arena/new-alto-k10/slide-show/exterior_web_04.webp',
    thumbnail:
      'https://images-saboomaruti-in.s3.ap-south-1.amazonaws.com/Arena/new-alto-k10/slide-show/exterior_web_04.webp',
  },
  {
    original:
      'https://images-saboomaruti-in.s3.ap-south-1.amazonaws.com/Arena/new-alto-k10/slide-show/exterior_web_05.webp',

    thumbnail:
      'https://images-saboomaruti-in.s3.ap-south-1.amazonaws.com/Arena/new-alto-k10/slide-show/exterior_web_05.webp',
  },
  {
    thumbnail:
      'https://images-saboomaruti-in.s3.ap-south-1.amazonaws.com/Arena/new-alto-k10/slide-show/highlight_web_01.webp',

    original:
      'https://images-saboomaruti-in.s3.ap-south-1.amazonaws.com/Arena/new-alto-k10/slide-show/highlight_web_01.webp',
  },
  {
    original:
      'https://images-saboomaruti-in.s3.ap-south-1.amazonaws.com/Arena/new-alto-k10/slide-show/Interior_web_01.webp',

    thumbnail:
      'https://images-saboomaruti-in.s3.ap-south-1.amazonaws.com/Arena/new-alto-k10/slide-show/Interior_web_01.webp',
  },
  {
    thumbnail:
      'https://images-saboomaruti-in.s3.ap-south-1.amazonaws.com/Arena/new-alto-k10/slide-show/Interior_web_02.webp',

    original:
      'https://images-saboomaruti-in.s3.ap-south-1.amazonaws.com/Arena/new-alto-k10/slide-show/Interior_web_02.webp',
  },
  {
    original:
      'https://images-saboomaruti-in.s3.ap-south-1.amazonaws.com/Arena/new-alto-k10/slide-show/Interior_web_03.webp',

    thumbnail:
      'https://images-saboomaruti-in.s3.ap-south-1.amazonaws.com/Arena/new-alto-k10/slide-show/Interior_web_03.webp',
  },
  {
    original:
      'https://images-saboomaruti-in.s3.ap-south-1.amazonaws.com/Arena/new-alto-k10/slide-show/Interior_web_04.webp',
    thumbnail:
      'https://images-saboomaruti-in.s3.ap-south-1.amazonaws.com/Arena/new-alto-k10/slide-show/Interior_web_04.webp',
  },
];

const altoK10Colors = [
  {
    id: 1,
    img: 'https://images-saboomaruti-in.s3.ap-south-1.amazonaws.com/Arena/new-alto-k10/colors/color_range_688x360_red.webp', color: "#BF001B"
  },
  {
    id: 2,
    img: 'https://images-saboomaruti-in.s3.ap-south-1.amazonaws.com/Arena/new-alto-k10/colors/color_range_688x360_blue.webp',
  },
  {
    id: 3,
    img: 'https://images-saboomaruti-in.s3.ap-south-1.amazonaws.com/Arena/new-alto-k10/colors/color_range_688x360_grey.webp',
  },

  {
    id: 4,
    img: 'https://images-saboomaruti-in.s3.ap-south-1.amazonaws.com/Arena/new-alto-k10/colors/color_range_688x360_silver.webp',
  },
  {
    id: 5,
    img: 'https://images-saboomaruti-in.s3.ap-south-1.amazonaws.com/Arena/new-alto-k10/colors/color_range_688x360_white.webp',
  },
  {
    id: 6,
    img: 'https://images-saboomaruti-in.s3.ap-south-1.amazonaws.com/Arena/new-alto-k10/colors/color_range_688x360_gold.webp',
  },
  {
    id: 7,
    img: 'https://images-saboomaruti-in.s3.ap-south-1.amazonaws.com/Arena/cars/alto-k10/altok10-black.webp',
  },
];

const altok10Mileage = [
  {
    id: 1,
    title: 'STD',
    transmission: 'MANUAL',
    mileage: '24.39',
    price: '₹ 4,09,000 Lakh',
  },
  {
    id: 2,
    title: 'LXI',
    transmission: 'MANUAL',
    mileage: '-',
    price: '₹ 4,93,500 Lakh',
  },
  {
    id: 3,
    title: 'VXI',
    transmission: 'MANUAL',
    mileage: '-',
    price: '₹ 5,14,500 Lakh',
  },
  {
    id: 4,
    title: 'VXI CNG',
    transmission: 'MANUAL',
    mileage: '-',
    price: '₹ 6,04,500 Lakh',
  },
  {
    id: 5,
    title: 'VXI+',
    transmission: 'MANUAL',
    mileage: '-',
    price: '₹ 5,49,500 Lakh',
  },
  {
    id: 6,
    title: 'VXI AGS',
    transmission: 'AUTOMATIC',
    mileage: '-',
    price: '₹ 5,64,500 Lakh',
  },
  {
    id: 7,
    title: 'VXI+ AGS',
    transmission: 'AUTOMATIC',
    mileage: '24.90 km/l',
    price: '₹ 5,99,500 Lakh',
  },
  {
    id: 8,
    title: '',
    transmission: '',
    mileage: '',
    price: '',
  },
];

const altoK10Variants = [
  {
    id: 1,
    title: 'Petrol',
    transmission: 'MANUAL',
    mileage: '24.39 KM/L',
  },
  {
    id: 2,
    title: 'Petrol',
    transmission: 'AUTOMATIC',
    mileage: '24.90 KM/L',
  },
  {
    id: 3,
    title: 'VXi CNG',
    transmission: 'MANUAL',
    mileage: '33.85 KM/KG',
  },
  {
    id: 4,
    title: 'LXI CNG',
    transmission: 'MANUAL',
    mileage: '33.40 KM/KG',
  },
];
 const altok10Data = {
  name: "Alto K10",
  brand: "Maruti Suzuki",
  priceRange: "₹  4.09 - 5.99 Lakh*",
  specs: [
    { label: "Engine", value: "998 cc",icon: "https://images-saboomaruti-in.s3.ap-south-1.amazonaws.com/Arena/local/speedometer.png",  },
    { label: "Mileage", value: "33.85 km/kg*",icon: "https://images-saboomaruti-in.s3.ap-south-1.amazonaws.com/Arena/local/gas-station.png", },
    { label: "Power (KW)", value: "49" ,icon : "https://images-saboomaruti-in.s3.ap-south-1.amazonaws.com/Arena/local/car.png", },
  ],
  iconUrls: [
    "https://images-saboomaruti-in.s3.ap-south-1.amazonaws.com/Arena/icons/AGS.webp",
    "https://images-saboomaruti-in.s3.ap-south-1.amazonaws.com/Arena/icons/S-CNG_mimimum+black.webp",
    "https://images-saboomaruti-in.s3.ap-south-1.amazonaws.com/Arena/icons/K-SERIES.webp",
  ],
  brochureLink:
    "https://images-saboomaruti-in.s3.ap-south-1.amazonaws.com/Arena/new-alto-k10/alto-k10-brochure.pdf",
  compareLink: "/compare-cars",
  cngLink: "/alto-k10-cng",
};

export { altoK10Sliders, altoK10Colors, altoK10Variants, altok10Mileage,altok10Data};
